
export const CLASS_TABS_SAVED = 'tabs-saved';
export const CLASS_TABS_TRANSLATED = 'tabs-translated';
export const CLASS_PLAY_CONTROL = 'play-control'; // LNG-764 stop video on any click except this
export const CLASS_MAIN_VIDEO = 'main-video';
